import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

// ─── Lazy-loaded route chunks (splits bundle per page) ──────────
const Home             = lazy(() => import('../page/Home'));
const Shop             = lazy(() => import('../components/shop'));
const Checkout         = lazy(() => import('../components/checkOut'));
const About            = lazy(() => import('../page/About'));
const Contact          = lazy(() => import('../page/Contact'));
const Blog             = lazy(() => import('../page/Blog'));
const ProductDetails   = lazy(() => import('../components/productDetails'));
const Account          = lazy(() => import('../page/Account'));
const TrackOrder       = lazy(() => import('../page/TrackOrder'));
const Login            = lazy(() => import('../page/Login'));
const Register         = lazy(() => import('../page/Register'));
const Wishlist         = lazy(() => import('../components/wishlist'));
const Cart             = lazy(() => import('../page/Cart'));
const TermsConditions      = lazy(() => import('../page/policies/TermsConditions'));
const PrivacyPolicy        = lazy(() => import('../page/policies/PrivacyPolicy'));
const CancellationReturns  = lazy(() => import('../page/policies/CancellationReturns'));
const SecurityPolicy       = lazy(() => import('../page/policies/SecurityPolicy'));

// ─── Fallback spinner shown while a chunk is loading ────────────
const PageLoader = () => (
  <div style={{
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    minHeight: '60vh', flexDirection: 'column', gap: '12px'
  }}>
    <div style={{
      width: '36px', height: '36px',
      border: '3px solid #f0f0f0',
      borderTopColor: '#e8179c',
      borderRadius: '50%',
      animation: 'spin .7s linear infinite'
    }} />
    <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
  </div>
);

export default function Router() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/"                     element={<Home />} />
        <Route path="/shop"                 element={<Shop />} />
        <Route path="/checkout"             element={<Checkout />} />
        <Route path="/about"                element={<About />} />
        <Route path="/contact"              element={<Contact />} />
        <Route path="/blog"                 element={<Blog />} />
        <Route path="/product/:id"          element={<ProductDetails />} />
        <Route path="/account"             element={<Account />} />
        <Route path="/track-order"          element={<TrackOrder />} />
        <Route path="/track-order/:orderId" element={<TrackOrder />} />
        <Route path="/login"               element={<Login />} />
        <Route path="/wishlist"            element={<Wishlist />} />
        <Route path="/cart"               element={<Cart />} />
        <Route path="/register"            element={<Register />} />
        <Route path="/terms"              element={<TermsConditions />} />
        <Route path="/privacy"            element={<PrivacyPolicy />} />
        <Route path="/returns"            element={<CancellationReturns />} />
        <Route path="/security"           element={<SecurityPolicy />} />
        {/* 404 — fallback to Shop */}
        <Route path="*"                   element={<Shop />} />
      </Routes>
    </Suspense>
  );
}